import IconStatusDot from '@apollo/icons/default/IconStatusDot.svg';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@apollo/orbit';
import React from 'react';

import { BodyViewer } from '../components/BodyViewer';
import { EmptyState } from '../components/EmptyState';
import { ConnectorsDebuggingData } from '../shared';

import { RequestOverview } from './RequestOverview';
import { ResponseMapping } from './ResponseMapping';
import { ResponseOverview } from './ResponseOverview';

export interface ResponseTabsProps {
  data: ConnectorsDebuggingData | undefined;
  showMappingErrorFirst?: boolean;
}

export const ResponseTabs = ({
  data,
  showMappingErrorFirst,
}: ResponseTabsProps) => {
  const request = data?.request;
  const response = data?.response;
  const selection = response?.body?.selection;
  const selectionErrorCount = selection?.errors?.length ?? 0;

  const errorViewIdx = request?.body ? 4 : 3;

  return (
    <Tabs
      className="flex flex-1 flex-col gap-4 overflow-hidden"
      defaultIndex={showMappingErrorFirst ? errorViewIdx : 0}
    >
      <TabList>
        <Tab>Request overview</Tab>
        {!!request?.body && <Tab>Request body</Tab>}
        <Tab>Response overview</Tab>
        <Tab>Response body</Tab>
        <Tab>
          Mapping
          {selectionErrorCount ? (
            <IconStatusDot className="ml-2 text-icon-warning" />
          ) : (
            ''
          )}
        </Tab>
      </TabList>
      <TabPanels className="flex flex-1 overflow-hidden">
        <TabPanel className="flex-1 overflow-auto px-2">
          {request ? (
            <RequestOverview request={request} />
          ) : (
            <EmptyState message="No request details to show" />
          )}
        </TabPanel>
        {!!request?.body && (
          <TabPanel className="flex-1 overflow-auto px-2">
            <BodyViewer
              content={request.body.content}
              kind={request.body.kind}
              className="size-full"
            />
          </TabPanel>
        )}
        <TabPanel className="flex-1 overflow-auto px-2">
          {response ? (
            <ResponseOverview response={response} />
          ) : (
            <EmptyState message="No response details to show" />
          )}
        </TabPanel>
        <TabPanel className="flex-1 overflow-auto px-2">
          {response?.body ? (
            <BodyViewer
              content={response.body.content}
              kind={response.body.kind}
              className="size-full"
            />
          ) : (
            <EmptyState message="No response body to show" />
          )}
        </TabPanel>
        <TabPanel className="flex-1 overflow-auto px-2">
          {selection ? (
            <ResponseMapping
              selection={selection}
              showErrorViewFirst={showMappingErrorFirst}
            />
          ) : (
            <EmptyState message="No selection mapping to show" />
          )}
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
